import { render, staticRenderFns } from "./LifeskillNumberTag.vue?vue&type=template&id=80b2646e&scoped=true&"
import script from "./LifeskillNumberTag.vue?vue&type=script&lang=js&"
export * from "./LifeskillNumberTag.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillNumberTag.vue?vue&type=style&index=0&id=80b2646e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2646e",
  null
  
)

export default component.exports